import React from "react";

export default function Pagination({ pagination, onPageChange }) {
  const { currentPage, totalPages } = pagination;

  // if (pagination) return null;
  if (totalPages <= 1) return null;

  const getPages = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages,
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages,
        );
      }
    }

    return pages;
  };

  return (
    <div className="flex items-center justify-start gap-2 mt-8">
      {/* Previous */}
      {/* <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`h-9 px-3 rounded-xl border text-sm font-medium transition
          ${
            currentPage === 1
              ? "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
              : "bg-white text-gray-700 border-gray-200 hover:bg-gray-100"
          }
        `}
      >
        Prev
      </button> */}

      {/* Pages */}
      {getPages().map((page, index) =>
        page === "..." ? (
          <span
            key={`dots-${index}`}
            className="px-2 text-gray-400 select-none"
          >
            ...
          </span>
        ) : (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`h-9 w-9 rounded-xl  text-sm font-medium transition-all duration-200
              ${page === currentPage
                ? "bg-[#292E32] text-white   scale-105"
                : "bg-transparent dark:text-white text-black  hover:bg-[#292e327c] "
              }
            `}
          >
            {page}
          </button>
        ),
      )}

      {/* Next */}
      {/* <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`h-9 px-3 rounded-full border text-sm font-medium transition
          ${
            currentPage === totalPages
              ? "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
              : "bg-white text-gray-700 border-gray-200 hover:bg-gray-100"
          }
        `}
      >
        Next
      </button> */}
    </div>
  );
}
